import AlertWithIcon from '@/src/common/components/elements/Alerts/AlertWithIcon'

const DelayForEGiftAlert = () => {
    return (
        <AlertWithIcon
            iconName={'warning'}
            size={'sm'}
            style={{ marginBottom: 15 }}
        >
            <ul>
                <li style={{ marginBottom: 5 }}>
                    This process takes up to 24 hours to complete.
                </li>
                <li>
                    Once you select confirm, you will not be able to select a
                    different redemption option.
                </li>
            </ul>
        </AlertWithIcon>
    )
}

export default DelayForEGiftAlert
